import { envVars } from '@core/environment/env-vars'

export const AUTH_CONFIG = {
    app_id: envVars.REACT_APP_SSO_APP_ID,
    audience_api: envVars.REACT_APP_SSO_AUDIENCE_API,
    return_endpoint: envVars.REACT_APP_SSO_RETURN_ENDPOINT,
    api_url: '/auth',
}
